import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {AdService} from '@services/ad.service';

@Component({
    selector: 'app-widget-notes',
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    constructor(
        private adService: AdService) {
    }

    ngOnInit() {
    }

    edit(event, fields = '') {
        this.adService.updateFavoriteText(this.favorite, this.favorite.comment, 'comment');
    }

}
